import React from "react"
import { MenuItem, FormHelperText, Select, FormControl } from "@mui/material"
import { useFormikContext } from "formik"
import { STATUS_PENDING, RESERVATION_COLORS, type ReservationStatus } from "@/constants/reservations"
import i18n from "@/i18n"

interface StatusFieldProps {
  statuses: ReservationStatus[]
  showHelperText?: boolean
}

const StatusField: React.FC<StatusFieldProps> = ({ statuses, showHelperText = true }) => {
  const { values, handleChange } = useFormikContext<{ status: string }>()
  const currentStatus = values.status as ReservationStatus
  const bgColor = RESERVATION_COLORS[currentStatus]?.main ?? "#6b7280"

  return (
    <div className="space-y-1" data-testid="panel-reservations-status-field">
      <FormControl fullWidth>
        <Select
          name="status"
          value={values.status}
          onChange={handleChange}
          data-testid="panel-reservations-status-field-select"
          sx={{
            backgroundColor: bgColor,
            borderRadius: "6px",
            "& .MuiSelect-select": {
              color: "white",
              padding: "8px 12px",
              textAlign: "center",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiSelect-icon": {
              color: "white",
            },
          }}
        >
          {statuses.map((status) => (
            <MenuItem key={status} value={status} data-testid={`panel-reservations-status-field-option-${status}`}>
              {i18n.t(`app.reservation.status.${status}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {showHelperText && values.status === STATUS_PENDING && (
        <FormHelperText className="text-gray-600">
          {i18n.t("app.create_reservation.pending_helper_text")}
        </FormHelperText>
      )}
    </div>
  )
}

export default StatusField
